module.exports = __webpack_public_path__ + "8cfb7aebe10c86994b53591da387780d.png";